export function NotItems(styleClass) {
  return <p className={styleClass}>Not Items</p>;
}
